import { baseApi } from '@/lib/store/api/baseQuery'
import { apiEndpoints, TRACKED_LINK_CONFIRMATION_ENDPOINT } from '@/lib/api/endpoints'

export async function parseTrackedLinkConfirmationResponse(response: Response): Promise<null> {
    if (response.status === 204) return null
    const contentType = response.headers.get('content-type')
    if (contentType?.includes('json')) {
        await response.json().catch(() => undefined)
    }
    throw new Error('tracked_link_confirmation_not_no_content')
}

export const trackedLinksApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        [TRACKED_LINK_CONFIRMATION_ENDPOINT]: builder.mutation<void, void>({
            query: () => ({
                url: apiEndpoints.trackedLinks.confirm,
                method: 'POST',
                validateStatus: (response: Response) => response.status === 204,
                responseHandler: parseTrackedLinkConfirmationResponse,
            }),
            invalidatesTags: [],
        }),
    }),
    overrideExisting: false,
})

export const { useConfirmTrackedLinksMutation } = trackedLinksApi
